import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import cn from 'classnames';
import styles from './Description.scss';
import { getBuildingType } from '../helper';
import { gaEvent, trackGA } from 'services/ga';

class Description extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isHidden: true
    };

    this.handleButtonClick = this.handleButtonClick.bind(this);
  }

  componentDidMount() {
    this.handleTrackEvent({
      eventName: 'buildingInfoBlocksShow',
      eventLabel: 'opisanie'
    });
  }


  handleButtonClick() {
    const { isHidden } = this.state;
    this.handleTrackEvent({
      eventName: 'buildingInfoBlocksExpand',
      eventLabel: isHidden ? 'podrobnee' : 'svernut',
      eventContent: 'opisanie'
    });
    this.setState({ isHidden: !isHidden });
  }

  handleTrackEvent = ({ eventName, eventLabel, eventContent }) => {
    const { building, objectType, profile } = this.props;
    const { title, id } = building.data;

    trackGA(gaEvent[eventName]({
      eventLabel,
      eventContent,
      productType: objectType,
      productName: title,
      productID: id,
      user_id: profile.id
    }));
  };

  render() {
    const { className, building, client, print, t } = this.props;
    const { description, type_id } = building.data;
    const { isHidden } = this.state;

    return description ? (
      <div className={cn(styles.DescriptionWrap, { [styles.DescriptionWrapClient]: client }, { [styles.DescriptionWrapPrint]: print })}>
        {client ? (
          <p className={styles.ClientDescriptionTitle}>
            {t('components.building.main.description.about', { type: getBuildingType(type_id) })}
          </p>
          ) : (
            <div className={cn(styles.OnlyMobile, styles.DescriptionTitle)}>
              {t('components.building.main.description.about', { type: getBuildingType(type_id) })}
            </div>
          )}
        <div className={client ? styles.DescriptionClient : cn(styles.Description, className)}>
          <div className={cn(styles.Inner, { [styles.isHidden]: isHidden })} >
            <div className={styles.Text} dangerouslySetInnerHTML={{ __html: description }} />
            { this.props.children }
          </div>
          <div className={client ? cn(styles.Button, styles.Button) : styles.Button} onClick={this.handleButtonClick}>
            <span>{isHidden ? (client ? t('components.building.main.description.readMore') : t('components.building.main.description.more')) : t('components.building.main.description.minimize')} <i className={isHidden ? null : styles.Opened}></i></span>
          </div>
        </div>
      </div>
    ) : null;
  }
}

export default withTranslation()(Description);



// WEBPACK FOOTER //
// ./src/components/Building/Main/Description/Description.js